import React, { useState } from 'react';

const FAQS = [
  { q: 'How do I upload a report for a patient?', a: 'Go to the Upload tab, select a patient from the Accepted list, fill in the report details and attach the file, then tap Send Request.' },
  { q: 'How long does it take for patient to accept?', a: 'The patient receives an instant notification and can accept or reject at any time. There is no expiry on the request.' },
  { q: 'What file formats are supported?', a: 'You can upload PDF, JPG, and PNG files. Maximum file size is 10MB per upload.' },
  { q: 'Why is a patient showing as Pending?', a: 'Pending means the patient has not yet accepted your upload request. You can resend or contact the patient directly.' },
  { q: 'How do I update my lab information?', a: 'Go to Profile → Lab Information to view your registered details. To update, contact our support team.' },
  { q: 'How do I contact support?', a: 'Email us at support@myhealthjournal.in or call 1800-XXX-XXXX (Mon–Sat, 9AM–6PM).' },
];

export default function MobileProviderHelpCenter({ onBack }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="pb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="flex items-center gap-3 px-4 py-4 bg-white border-b border-gray-100 shadow-sm">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100">
          <span className="material-symbols-outlined text-gray-500">arrow_back</span>
        </button>
        <p className="font-black text-lg text-[#141a3d]">Help Center</p>
      </div>

      <div className="px-4 mt-4 space-y-3">
        {FAQS.map((faq, i) => (
          <div key={i} className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)}
              className="w-full flex items-center justify-between px-4 py-4 text-left active:bg-gray-50">
              <p className="font-bold text-sm text-[#141a3d] flex-1 pr-3">{faq.q}</p>
              <span className="material-symbols-outlined text-gray-400 shrink-0" style={{ fontSize: '20px' }}>
                {openIndex === i ? 'expand_less' : 'expand_more'}
              </span>
            </button>
            {openIndex === i && (
              <div className="px-4 pb-4 border-t border-gray-100">
                <p className="text-sm text-gray-500 leading-relaxed pt-3">{faq.a}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}